import 'babel-polyfill';

import React    from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import { createStore, applyMiddleware } from 'redux';
import { Provider }                     from 'react-redux';
import thunk                            from 'redux-thunk';

import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import reducers from './reducers';
import './assets/styles/global/base.scss';

import { isCookieEnabled } from './services/cookieChecks';

import Page                 from './components/Page';
import EventsPage           from './components/EventsPage';
import EventDetailPage      from './components/EventDetailPage';
import BookingPage          from './components/BookingPage';
import LoginPage            from './components/LoginPage';
import Dashboard            from './components/Dashboard';
import TransactionList      from './components/TransactionList';
import StatsList            from './components/StatsList';
import PresenterList        from './components/PresenterList';
import VenueList            from './components/VenueList';
import ResourceList         from './components/ResourceList';
import AdminModulePage      from './components/AdminModulePage';
import TimetableList        from './components/TimetableList';
import CourseList           from './components/CourseList';
import EventList            from './components/EventList';
import MarketingPage        from './components/MarketingPage';
import PublicCourseListPage from './components/PublicCourseListPage';
import PromotionList        from './components/PromotionList';
import CourseDetailPage     from './components/CourseDetailPage';
import MarketingList        from './components/MarketingList';
import ELearningList        from "./components/ELearningList";
import MarketingPageAdForm  from "./components/MarketingPageAdForm";

import authenticator from './services/authenticator';

var store = applyMiddleware(thunk)(createStore)(reducers);

function cookieToggleCheck() {
    if (window.config.ga_measurement_id) {
        const gaDisableKey = `ga-disable-${window.config.ga_measurement_id}`;
        window[gaDisableKey] = !isCookieEnabled('ANALYTICS');
    }

    if(window.dataLayer) {
        dataLayer.push({
            'event': 'hotjar_toggle',
            'is_hotjar_enabled': isCookieEnabled('HOTJAR')
        });
    }
}

cookieToggleCheck();

document.addEventListener('consentCookieChange', cookieToggleCheck);

const authorizeDashboardAccess = (nextState, replace, callback) => {

    if (!authenticator.getSessionToken()) {

        replace('/login');

    } else if (authenticator.isSessionExpired()) {

        replace('/login?expired=true');
    }

    callback();
};

function handleUpdate() {

    let { action, hash } = this.state.location;

    if (hash !== '') {

        redirectToHtml5Url(hash);
    }

    if (action === 'PUSH') {

        scrollToTopOfPage();
    }
}

function redirectToHtml5Url(hash) {

    browserHistory.push(hash.replace('#', ''));
}

function scrollToTopOfPage() {

    window.scrollTo(0, 0);
}

Sentry.init({
    dsn: 'https://e529fe7ca6de4112a7357dc73dbad8fc@sentry.io/1303158',
    environment: window.config.environment
});

ReactDOM.render(

    <Provider store={ store }>

        <Router onUpdate={ handleUpdate } history={ browserHistory }>

            <Route path="/" component={ MarketingPage } />

            <Route component={ Page }>

                <Route path="courses" component={ PublicCourseListPage } />
                <Route path="e-learning" component={ PublicCourseListPage } />
                <Route path="conferences" component={ PublicCourseListPage } />
                <Route path="events" component={ EventsPage } />
                <Route path="events/:eventId" component={ EventDetailPage } />
                <Route path="events/:eventId/:slug" component={ EventDetailPage } />
                <Route path="courses/:courseId" component={ CourseDetailPage } />
                <Route path="courses/:courseId/:slug" component={ CourseDetailPage } />
                <Route path="booking/:eventId" component={ BookingPage } />
                <Route path="booking/elearning/:courseId" component={ BookingPage } />

            </Route>

            <Route path="login" component={ LoginPage } />

            <Route path="/dashboard" component={ Dashboard } onEnter={ authorizeDashboardAccess }>

                <IndexRoute component={ EventList } />
                <Route path="stats" component={ StatsList } />
                <Route path="transactions" component={ TransactionList } />
                <Route path="presenters" component={ PresenterList } />
                <Route path="venues" component={ VenueList } />
                <Route path="resources" component={ ResourceList } />
                <Route path="modules" component={ AdminModulePage } />
                <Route path="timetables" component={ TimetableList } />
                <Route path="courses" component={ CourseList } />
                <Route path="events" component={ EventList } />
                <Route path="promotions" component={ PromotionList } />
                <Route path="marketing" component={ MarketingList } />
                <Route path="elearning" component={ ELearningList } />
                <Route path="marketing-page-ad" component={ MarketingPageAdForm } />

            </Route>

        </Router>

    </Provider>,

    document.getElementById('content')
);



// WEBPACK FOOTER //
// ./index.js